import { pageRoute } from "../routeFactory";

const SusPlanForeword = () => import("@/views/SusPlanForeword.vue");
const SusPrioritiesPage = () => import("@/views/susPriorities.vue");
const GreenhouseGasesPage = () => import("@/views/greenhouseGases.vue");
const NaturePositivePage = () => import("@/views/NaturePositive.vue");
const CircularEconomyPage = () => import("@/views/CircularEconomy.vue");
const ClimateChangeAdaptationPage = () =>
  import("@/views/ClimateChangeAdaptation.vue");
const EnablingSocialValuePage = () => import("@/views/EnablingSocialValue.vue");
const EmpoweringSustainableChangePage = () =>
  import("@/views/EmpoweringSustainableChange.vue");

const section = "sus-plan";

export const susPlanChildren = [
  pageRoute({
    path: "sus-foreword",
    name: "SusForeword",
    component: SusPlanForeword,
    section,
    bodyClass: "sus-foreword",
    titleKey: "nav.sus-foreword",
  }),
  pageRoute({
    path: "sus-priorities",
    name: "SusPriorities",
    component: SusPrioritiesPage,
    section,
    bodyClass: "sus-priorities",
    titleKey: "nav.sus-priorities",
  }),
  pageRoute({
    path: "greenhouse-gases",
    name: "SusGreenhouseGases",
    component: GreenhouseGasesPage,
    section,
    bodyClass: "greenhouse-gases",
    titleKey: "nav.greenhouse-gases",
  }),
  pageRoute({
    path: "nature-positive",
    name: "SusNaturePositive",
    component: NaturePositivePage,
    section,
    bodyClass: "nature-positive",
    titleKey: "nav.nature-positive",
  }),
  pageRoute({
    path: "circular-economy",
    name: "SusCircularEconomy",
    component: CircularEconomyPage,
    section,
    bodyClass: "circular-economy",
    titleKey: "nav.circular-economy",
  }),
  pageRoute({
    path: "climate-change-adaptation",
    name: "SusClimateChangeAdaptation",
    component: ClimateChangeAdaptationPage,
    section,
    bodyClass: "climate-change-adaptation",
    titleKey: "nav.climate-change-adaptation",
  }),
  pageRoute({
    path: "enabling-social-value",
    name: "SusEnablingSocialValue",
    component: EnablingSocialValuePage,
    section,
    bodyClass: "enabling-social-value",
    titleKey: "nav.enabling-social-value",
  }),
  pageRoute({
    path: "sustainable-change",
    name: "SusEmpoweringSustainableChange",
    component: EmpoweringSustainableChangePage,
    section,
    bodyClass: "sustainable-change",
    titleKey: "nav.sustainable-change",
  }),
];
